var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 13 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kos-ikony-201120",
    transform: "translate(-504.000000, -336.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background",
    transform: "translate(-19.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "obnovit3",
    transform: "translate(523.000000, 336.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0622811,4.1803418 C9.83836406,2.98327148 8.21102765,2.32400391 6.48014055,2.32400391 L5.53009217,2.32400391 L7.05495622,0.828925781 L6.20534332,0 L3.23553226,2.91178711 L6.16658295,5.82647461 L7.02215668,5.0034375 L5.50795622,3.49769531 L6.48014055,3.49769531 C9.39160138,3.49769531 11.7602673,5.814375 11.7602673,8.66200195 C11.7602673,11.5096289 9.39160138,13.8263086 6.48014055,13.8263086 C3.56867972,13.8263086 1.20001382,11.5095996 1.20001382,8.66188477 L1.20001382,8.07503906 L0,8.07515625 L0,8.66200195 C0,10.3549512 0.674052995,11.9465625 1.898,13.1436328 C3.12191705,14.3407324 4.74925346,15 6.48014055,15 C8.21102765,15 9.83836406,14.3407324 11.0622811,13.1436328 C12.2862281,11.9465332 12.9602811,10.3549219 12.9602811,8.66200195 C12.9602811,6.96908203 12.2862281,5.37744141 11.0622811,4.1803418 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/RefreshIcon.a6010f198bc673be7b62e090bb331efc.svg";
export { ForwardRef as ReactComponent };